import * as Tooltip from "@radix-ui/react-tooltip";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import ProfileAvatar from "app/components/ProfileAvatar";
import { getMembersByIds } from "app/containers/Features/components/MemberSelection/helper";
import {
  IMemberList,
  SearchForEnum,
} from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import React, { useEffect, useMemo } from "react";

interface AvatarGroupProps {
  membersIds: string[];
  maxVisible?: number;
  className?: string;
  circleClassName?: string;
  memberListData: IMemberList[];
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({
  membersIds,
  maxVisible = 5,
  className,
  circleClassName,
  memberListData,
}) => {
  const members = useMemo(() => {
    return getMembersByIds(memberListData, membersIds);
  }, [memberListData, membersIds]);

  const visibleMembers = members.slice(0, maxVisible);
  const hiddenMembers = members.slice(maxVisible);

  return (
    <Tooltip.Provider delayDuration={300}>
      <div className=" flex flex-row -space-x-2 ">
        {visibleMembers.map((member) => {
          const { _id, avatar, name } = member;
          return (
            <Tooltip.Root key={_id}>
              <Tooltip.Trigger asChild>
                {/* Make sure this button isn't covered by siblings */}
                <button
                  type="button"
                  className="relative z-10"
                  aria-label={name}
                >
                  <ProfileAvatar
                    name={name}
                    avatar={avatar}
                    hideStatus
                    className="border-2 border-white rounded-full "
                    circleClassName=" w-6 h-6  "
                  />
                </button>
              </Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content
                  className="bg-[#333E4D] text-white text-xs rounded-md py-2 px-3 shadow-lg z-50"
                  side="bottom"
                  align="center"
                  sideOffset={6}
                >
                  <MemberProfileAvatar
                    id={member._id}
                    circleClassName="!w-6 !h-6 "
                    nameClassName=" !text-[#FFFFFF] "
                    showFor={SearchForEnum.team}
                  />

                  <Tooltip.Arrow className="fill-[#333E4D]" />
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          );
        })}

        {hiddenMembers.length > 0 && (
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              {/* Use a button here for consistent trigger behavior */}
              <button
                type="button"
                className={clsx(
                  "w-8 h-8 rounded-full bg-secondary text-white flex items-center justify-center cursor-pointer border border-white shadow-md relative z-10",
                  className,
                )}
                aria-label={`+${hiddenMembers.length} more`}
              >
                +{hiddenMembers.length}
              </button>
            </Tooltip.Trigger>
            <Tooltip.Portal>
              <Tooltip.Content
                className="bg-[#333E4D] text-white text-xs rounded-md p-2 shadow-lg z-50 space-y-2"
                side="bottom"
                align="center"
                sideOffset={6}
              >
                {hiddenMembers.map((member) => {
                  return (
                    <MemberProfileAvatar
                      id={member._id}
                      circleClassName="!w-6 !h-6 "
                      nameClassName=" !text-[#FFFFFF] "
                      showFor={SearchForEnum.team}
                    />
                  );
                })}
                <Tooltip.Arrow className="fill-[#333E4D]" />
              </Tooltip.Content>
            </Tooltip.Portal>
          </Tooltip.Root>
        )}
      </div>
    </Tooltip.Provider>
  );
};

export default AvatarGroup;
